import React from 'react';
import { Form } from 'react-bootstrap';
import { computeItineraryPricing } from './pricingHelpers';
import dw from './daywiseItinerary.module.css';

const PricingSummary = ({ data, travellers, onTravellersChange, bookingState }) => {
  const pricing = computeItineraryPricing(data, travellers, bookingState);

  const setField = (field, value) => {
    if (onTravellersChange) {
      onTravellersChange({ ...travellers, [field]: Math.max(0, parseInt(value, 10) || 0) });
    }
  };

  const lines = [
    ['Accommodation', pricing.accommodation],
    ['Journeys + local travel', pricing.transport],
    ['Sightseeing, meals, activities', pricing.services],
    ['Supplier cost', pricing.supplierCost],
    [`Markup (${pricing.markupPct}%)`, pricing.markup],
    [`GST (${pricing.gstRate}% ${pricing.gstMode})`, pricing.gst],
  ];

  return (
    <div>
      <h5>Live package summary</h5>
      <p className={dw.summaryDesc}>Based on the manually allocated booking party</p>

      <div className={dw.stat}>
        <small>
          Final price · {pricing.pax} traveller{pricing.pax === 1 ? '' : 's'}
        </small>
        <strong>₹{pricing.total.toFixed(0)}</strong>
        <small>
          {pricing.pax > 0
            ? `₹${pricing.perPerson.toFixed(0)} average per person`
            : 'Add travellers for per-person price'}
        </small>
      </div>

      {[
        ['indianAdults', 'Indian adults'],
        ['foreignAdults', 'Foreign adults'],
        ['childrenWithBed', 'Children (with bed)'],
        ['childrenNoBed', 'Children (no bed)'],
      ].map(([key, label]) => (
        <div key={key} className={dw.field} style={{ marginBottom: 8 }}>
          <label className={dw.fieldLabel}>{label}</label>
          <Form.Control
            size="sm"
            type="number"
            min={0}
            value={travellers?.[key] ?? 0}
            onChange={(e) => setField(key, e.target.value)}
          />
        </div>
      ))}

      {lines.map(([label, amt]) => (
        <div key={label} className={dw.sumline}>
          <span>{label}</span>
          <strong>₹{amt.toFixed(0)}</strong>
        </div>
      ))}

      <div className={dw.sumlineTotal}>
        <span>Package amount</span>
        <strong>₹{pricing.total.toFixed(0)}</strong>
      </div>

      {pricing.alerts.length > 0 ? (
        <div className={dw.alertbox}>
          <b>⚠ {pricing.alerts.length} allocation / service checks</b>
          <br />
          {pricing.alerts[0]}
          {pricing.alerts.length > 1 ? '…' : ''}
        </div>
      ) : (
        <div className={dw.alertboxValid}>✓ All basic room allocations valid</div>
      )}

      {Object.keys(pricing.accommodationByCity).length > 0 && (
        <div style={{ marginTop: 14, fontSize: 12, color: '#445f79' }}>
          <b>Accommodation allocation</b>
          {Object.entries(pricing.accommodationByCity).map(([city, amt]) => (
            <p key={city} style={{ marginTop: 5, marginBottom: 0 }}>
              {city}
              <strong style={{ float: 'right' }}>₹{amt.toFixed(0)}</strong>
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default PricingSummary;
